import * as React from "react";
import Centre from "../../../domain/Centre";
import { UUID } from "../../../domain/UUID";
import { useCurrentSeason } from "../../exams/SeasonContext";
import { Stack, Typography } from "@mui/material";
import AdvancedStudentsCard from "./AdvancedStudentsCard";
import BfiStudentsCard from "./BfiStudentsCard";

interface Props {
  readonly centreId: UUID<Centre>
}

export default function StudentsSection({ centreId }: Props) {
  const { currentSeason } = useCurrentSeason();

  if (currentSeason === undefined) {
    return <Typography>Loading</Typography>;
  }

  return (
    <Stack spacing={1}>
      <AdvancedStudentsCard season={currentSeason} centreId={centreId} />
      <BfiStudentsCard season={currentSeason} centreId={centreId} />
    </Stack>
  );
}
